import React from 'react';

import I18n from 'utils/I18n';
import Cldr from 'utils/Cldr';
import clsx from '@strava/ui/clsx';

import { useCheckoutContext } from '../../../state/CheckoutContext';
import { getTrialProduct } from '../../../state/Checkout.actions';
import PromoButton from './PromoButton';

import styles from './Footer.scss';

export const I18nPrefix = 'strava.subscriptions.checkout.summary.organic';

export const Footer = () => {
  const { checkoutEntityState, dispatch } = useCheckoutContext();

  const {
    duration,
    isTrialEligible,
    products,
    promoCodeInputVisibility: isPromoCodeInputVisible
  } = checkoutEntityState;
  const cartData = products?.[duration];

  // only render `·` divider if both buttons are present
  const shouldShowPromoButton = !isPromoCodeInputVisible;
  const shouldShowDivider = shouldShowPromoButton && isTrialEligible;

  return (
    <div className={styles.summaryFooter}>
      <div className={styles.billedToday}>
        <div className={styles.billed}>
          <strong>{I18n.t(`${I18nPrefix}.billed_today`)}</strong>
        </div>
        <div className={styles.billedTotal}>
          <strong>
            {Cldr.formatCurrency(cartData.billedToday, cartData.currency)}
          </strong>
        </div>
      </div>
      <div className={styles.footerActions}>
        {shouldShowPromoButton && <PromoButton />}
        {shouldShowDivider && <span className={styles.actionDivider}>·</span>}
        {isTrialEligible && (
          <button
            className={clsx('btn', 'btn-link', styles.actionButton)}
            onClick={() => getTrialProduct(checkoutEntityState, dispatch)}
            type="button"
          >
            {I18n.t(`${I18nPrefix}.cta.redeem_trial_offer`)}
          </button>
        )}
      </div>
    </div>
  );
};

export default Footer;
